import { createSlice } from '@reduxjs/toolkit';

/**
 * Tracks the program requested by a custom program link (?organization=X&program=Y),
 * so the dashboard can prompt the user to join it if they're not already applying to it.
 *
 * Routes.js is the only place that dispatches `programLinkRequested`, right after login,
 * before it can reliably know whether that's a real mismatch. ProgramsDashboardContainer
 * is the only place that reads it and decides, once its own data has loaded, whether to
 * show the join-program prompt - then dispatches `programLinkConsumed` either way, so the
 * prompt only ever fires once per link visit.
 */
const initialState = {
  requestedProgramId: null,
};

const customProgramLinkSlice = createSlice({
  name: 'customProgramLink',
  initialState,
  reducers: {
    programLinkRequested(state, action) {
      state.requestedProgramId = action.payload;
    },
    programLinkConsumed(state) {
      state.requestedProgramId = null;
    },
  },
});

export const { programLinkRequested, programLinkConsumed } = customProgramLinkSlice.actions;
export const selectRequestedProgramId = state => state.customProgramLink.requestedProgramId;
export default customProgramLinkSlice.reducer;
